import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=7f6342b6&"
import script from "./PanelHeader.vue?vue&type=script&lang=ts&"
export * from "./PanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=7f6342b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports